export default __webpack_public_path__ + "static/media/WorkReports@32.e788ce70.svg";